import React from 'react';
import { Navigate } from 'react-router-dom';
import { isFeatureEnabled } from 'utils/featureAccess';

/**
 * FeatureRoute component - wraps a route and checks if the feature is enabled
 * @param {string} featureId - The feature ID required to access this route
 * @param {React.Component} element - The element to render if feature is enabled
 * @param {string} redirectTo - Optional redirect path if feature is not enabled
 */
const FeatureRoute = ({ featureId, element, redirectTo = '/guest/home' }) => {
  const hasAccess = isFeatureEnabled(featureId);
  
  if (!hasAccess) {
    return <Navigate to={redirectTo} replace />;
  }
  
  return element;
};

export default FeatureRoute;
